var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephoneInfoContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.375,
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69871 16.7271L11.1229 15.7157C11.5246 15.4305 11.9319 15.2393 12.3966 15.1156C12.9301 14.9735 13.1693 14.6823 13.1693 14.0601C13.1693 12.4817 16.8151 12.3137 16.8151 14.0601C16.8151 14.6823 17.0543 14.9735 17.5878 15.1156C18.0562 15.2403 18.463 15.4327 18.8615 15.7157L20.2857 16.7271C20.9301 17.1847 21.23 17.4059 21.3973 17.7576C21.5547 18.0886 21.5547 18.4767 21.5547 19.2528C21.5547 20.6482 21.5547 21.3459 21.164 21.7932C20.6908 22.3349 19.4605 22.2884 18.7049 22.2884H11.2795C10.5238 22.2884 9.31861 22.3635 8.82038 21.7932C8.42969 21.3459 8.42969 20.6482 8.42969 19.2528C8.42969 18.4767 8.42969 18.0886 8.58707 17.7576C8.75436 17.4059 9.05431 17.1847 9.69871 16.7271Z",
    stroke: "#2177FE",
    strokeWidth: 1.09375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4557 18.6458C16.4557 19.4512 15.8028 20.1042 14.9974 20.1042C14.192 20.1042 13.5391 19.4512 13.5391 18.6458C13.5391 17.8404 14.192 17.1875 14.9974 17.1875C15.8028 17.1875 16.4557 17.8404 16.4557 18.6458Z",
    stroke: "#2177FE",
    strokeWidth: 1.09375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3199 8.94626C10.3585 9.22073 9.66738 9.56123 9.03491 9.97207C8.03357 10.6225 7.60427 11.7946 7.72214 12.9256C7.77195 13.4036 8.15568 13.6322 8.60065 13.5085C8.93871 13.4146 9.27731 13.3231 9.61326 13.2235C10.5958 12.9321 10.8269 12.5778 10.9634 11.5721L11.3199 8.94626ZM11.3199 8.94626C13.6958 8.26791 16.2937 8.26791 18.6697 8.94626M18.6697 8.94626C19.6311 9.22073 20.3222 9.56123 20.9547 9.97207C21.956 10.6225 22.3853 11.7946 22.2674 12.9256C22.2176 13.4036 21.8339 13.6322 21.3889 13.5085C21.0509 13.4146 20.7123 13.3231 20.3763 13.2235C19.3938 12.9321 19.1627 12.5778 19.0262 11.5721L18.6697 8.94626Z",
    stroke: "#2177FE",
    strokeWidth: 1.09375,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneInfoContainer);
export default __webpack_public_path__ + "static/media/TelephoneInfoContainer.eb068a41b4bf68f9d324968e4d44c395.svg";
export { ForwardRef as ReactComponent };